// extracted by mini-css-extract-plugin
module.exports = {"controllerWrapper":"systemHistoryHeader_controllerWrapper__2QDYg","hide":"systemHistoryHeader_hide__36tVM"};